import { FREE_DELIVERY_THRESHOLD } from "@/constants/constants";

export enum DeliveryMessage {
  FreeStandardDelivery = "Free standard delivery",
  FreeStandardDeliveryOverThreshold = "Free standard delivery over {price}",
  FreeStandardDeliveryOverThresholdNew = "Free standard delivery over {price}, otherwise from £4.50",
  FreeUKMainlandDelivery = "Free UK mainland delivery",
  FreeUKMainlandDeliveryOverThreshold = `Free UK mainland delivery over £${FREE_DELIVERY_THRESHOLD}`,
  None = "",
}
